export default "/TOUCAN.996c2a3e4c4fe74a089eb2d1d335f665.svg";